import { Badge } from "@/components/ui/Badge";
import type { QAFlag } from "@/lib/types";

/** A compact summary of an isolate's open flags, for table rows (M-05). */
export function FlagBadges({ flags }: { flags: QAFlag[] }) {
  const open = flags.filter((flag) => flag.resolved_at === null);
  if (open.length === 0) return null;

  const blocking = open.filter((flag) => flag.severity === "blocking");
  const warnings = open.filter((flag) => flag.severity === "warning");

  return (
    <span className="inline-flex flex-wrap gap-1">
      {blocking.length > 0 && (
        <Badge tone="blocking">
          {blocking.length} blocking
          <span className="sr-only">
            : {blocking.map((f) => f.code).join(", ")}
          </span>
        </Badge>
      )}
      {warnings.length > 0 && (
        <Badge tone="warning">
          {warnings.length} to check
          <span className="sr-only">
            : {warnings.map((f) => f.code).join(", ")}
          </span>
        </Badge>
      )}
    </span>
  );
}
